module.exports = __webpack_public_path__ + "media/0012.5639cdd0.mp3";